// extracted by mini-css-extract-plugin
export default {"go-back-menu-div":"LinkButton_go-back-menu-div__jDrBc","message":"LinkButton_message__yt7b9","shop-here-link-div":"LinkButton_shop-here-link-div__n5asp"};